<template>
  <div  v-if="show_body">
    <!-- 测评答题 -->
    <answer-questions  :array="data.list" :interruptShow="interruptShow" :data_="data" :intro="data.intro?data.intro.split('\r'):[]" @saveReportHandle="saveReportHandle"></answer-questions>
    <!-- 未购买 -->
    <van-popup class="pub_alert" v-model="is_buy" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <router-link class="confirm" :to="{
            path:'/course_details',
            query:{
              bid:2
            }
          }">购买最佳工作模式课程</router-link>
        </div>
      </div>
    </van-popup>
    <!-- 判断链接是否失效 -->
    <van-popup class="pub_alert" v-model="failureShow" :close-on-click-overlay="false">
        <div class="confirm_box">
          <h2 class="on">{{failureMsg}}</h2>
        </div>
    </van-popup>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id" :cpBool="true"></public-level>
  </div>
</template>
<script>
import { bd_ceping64_index,bd_ceping64_answer,ceping_event} from '@/api/measurement'
import { deleteStorage} from '@/utils/tools'
import { shareCon} from "@/utils/wxconfig";
import AnswerQuestions from "@c/measurement/answer-questions";
import PublicLevel from '@c/course/public-level'
export default {
  data() {
      return {
        show_body: false,
        list: [],
        data: {},
        // 上一页面路由
        formPath: '',
        failureShow:false,
        interruptShow:false,
        failureMsg:'',
        // 关卡
        level_list_id:''
      }
    },
    components:{
      AnswerQuestions,
      PublicLevel
    },
    computed: {
      // 是否购买课程
      is_buy(){
        return (!this.data.is_buy && !this.data.msg)
      }
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 获得提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:28:13
      */
      saveReportHandle(arr){
        //调用加载中
        this.$emit('loadingHandle',true,"提交中...");
        bd_ceping64_answer({
          answer: JSON.stringify(arr)
        })
        .then((data) => {
          //关闭加载中
          this.$emit('loadingHandle',false);
          if (data.code == 10002) {
            this.$toast(data.data.msg);
            return false;
          }
          this.$toast('提交成功！');
          let q = this.$route.query;
          // 提交删除缓存 
          deleteStorage(this.$route.path);
          if (this.formPath === '/bd_ceping64_report') {
            this.$router.back();
          } else {
            this.$router.push({
              path: '/bd_ceping64_report',
              query: q
            })
          }
        })
      },
      /*
       *@param: 
       *@return: 
       *@Description: 数据初始化
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:27:41
      */
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        let obj = {
          state: this.$route.query.state,
        };
        if(this.$route.query.code){
          obj['code'] = this.$route.query.code;
        }
        bd_ceping64_index(obj)
          .then((data) => {
            if (data.code == 10002) {
              if (this.formPath === '/bd_ceping64_report') {
                this.$router.back();
              } else {
                // 已经测评完成
                this.$router.push({
                  path:'/bd_ceping64_report',
                  query:this.$route.query
                });
              }

            } else {
              this.data = data;
              document.title = data.headtitle;
              //判断是否是已购买课程并且链接已使用或者失效
              if(data.msg){
                this.failureMsg = data.msg;
                this.failureShow = true;
              }else{
                //判断是否是已购买课程并且有本地缓存
                if(data.is_buy && window.localStorage.getItem(this.$route.path)){
                  this.interruptShow = true;
                }
              }
              this.show_body = true;

              ceping_event({ lead_sid: this.$route.query.lead_sid,
                cid: data.cid,
                event: 'ViewIndex',
              }).then(res=>{
                // 页面访问统计
              });

              // 神策统计--打开页面时触发
              // sensors.track('evaluationPage', {
              //   evaluation_id: data.cid,
              //   evaluation_name: data.headtitle,
              //   evaluation_url: window.location.href,
              //   evaluation_page_title: data.headtitle,
              //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              // })
            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          })
      },
    },
    /*
     *@param: 
     *@return: 
     *@Description: 获取上一个页面的路由
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 15:27:53
    */
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.pullData();
      shareCon("ceping64", this);
    }
}
</script>
<style lang="scss" scoped>


.confirm_box {
  h2 {
    padding-bottom: 12px;
    padding: 40px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      width: 100%;
    }
  }
}
</style>

